<template>
  <main class="gate-auth">
    <section class="gate-auth__form">
      <div class="flex items-center justify-between gap-05">
        <NovatorFullDarkLogo />
        <LanguageSwitcher theme="light" />
      </div>
      <div class="gate-auth__content">
        <slot />
      </div>
      <p class="text-sm c-slate-500 mt-0 mb-0">{{ $t('footer.rights', { year }) }}</p>
    </section>
    <div class="gate-auth__image" aria-hidden="true">
      <img src="@/assets/images/auth-image.svg" alt="" class="side-image" />
    </div>
  </main>
</template>

<script setup>
import NovatorFullDarkLogo from '@/assets/images/logos/NovatorFullDarkLogo.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

/** Вход — раскладка Novator (frontend-js `AuthLayout`): форма слева, иллюстрация справа. */
const year = new Date().getFullYear()
</script>

<style scoped lang="scss">
@use '@/assets/styles/base/variables' as *;

.gate-auth {
  display: flex;
  // Высота окна, а не «не меньше»: иллюстрация (.side-image) по разметке вдвое выше экрана и
  // уменьшена transform-ом, без ограничения она растягивала страницу и уводила форму вниз.
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  padding: 0;
  background: $color-white;

  &__form {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 50%;
    padding: 32px;
    box-sizing: border-box;
    overflow-y: auto;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    padding: 32px 0;
  }

  &__image {
    width: 50%;
    overflow: hidden;
  }
}

@media (max-width: 600px) {
  .gate-auth {
    &__form {
      width: 100%;
      padding: 16px;
    }

    & {
      height: auto;
      min-height: 100dvh;
      overflow: visible;
    }

    &__image {
      display: none;
    }
  }
}
</style>
